import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgViewLayoutTop = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M1.75 6.75h16.5m-14.5 11.5h12.5a2 2 0 0 0 2-2V3.75a2 2 0 0 0-2-2H3.75a2 2 0 0 0-2 2v12.5a2 2 0 0 0 2 2Z"
	})]
});
const ForwardRef = forwardRef(SvgViewLayoutTop);
export { ForwardRef as ReactComponent };
